exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-item .comment-menu-dropdown[data-v-7d16d0cf]{display:none}.comment-item .comment-header:hover .comment-menu-dropdown[data-v-7d16d0cf]{display:block}@media (max-width:768px){.mobile-size[data-v-7d16d0cf]{margin-left:-13px!important}}.editor[data-v-7d16d0cf]{overflow:hidden;background-color:#e7e7e7}.edit-background[data-v-7d16d0cf]{background-color:#fff}", ""]);

// exports
